import React, { useEffect } from 'react';
import './App.css';
import MainLayout from './components/common/layouts/main-layout.tsx';
import AppRouter from './components/router';
import useAuthorization from './core/services/hooks/useAuthorization.ts'
import AdminService from './core/services/AdminService.ts';
import useFetch from './core/hooks/useFetch.ts';
import "./utils/pdf.ts";
import useAutoLogout from './core/services/hooks/useAutoLogout.ts'
import { useAppDispatch, useAppSelector } from './core/store/index.ts';
import { setSettings } from './core/store/reducers/settings-site.ts';
import { Flex, Spinner } from '@radix-ui/themes';
import { useNavigate } from 'react-router';
function App() {
  const dispatch = useAppDispatch()
  const settings = useAppSelector(state => state.settings.settings)
  const {authorization, isLoading, error, errors} = useAuthorization()
  const navigate = useNavigate()
  const [fetchSettingsSite, isLoadingSettingsSite, errorSettingsSite, errorsSettingsSite] = useFetch(async () => {
        const data = await AdminService.GetSettingsSite()
        dispatch(setSettings(data))
        document.title = data.name_site
  })
  const bootstrap = async () => {
    await authorization()
    await fetchSettingsSite()
  }
  useEffect(() => {
     bootstrap()
  }, [])
  useAutoLogout({timeout: 15 * 60 * 1000})
  useEffect(() => {
        navigate(JSON.parse(window.sessionStorage.getItem('lastRoute') || '{}'))
        window.onbeforeunload = () => {
            window.sessionStorage.setItem('lastRoute', JSON.stringify(window.location.pathname))
        }
    }, [])
   
  return (
    <MainLayout>
       <head>
        <link rel="shortcut icon" href={settings?.favicon_ico_url || ''} type="image/x-icon" />
      </head>
      <AppRouter 
       
      />
    </MainLayout>
  );

}

export default App;
